function heightDrawerMenu() {
  var heightAnnonce = parseInt(document.querySelector("#shopify-section-announcement-bar").offsetHeight);
  var headerHeader = parseInt(document.querySelector("header.header").offsetTop + document.querySelector("header.header").offsetHeight);
  var topPage = window.scrollY;

  if ( topPage < heightAnnonce ){
    document.documentElement.style.setProperty('--height-header', (headerHeader - 2 + heightAnnonce - topPage) + 'px');
  }else{
    document.documentElement.style.setProperty('--height-header', (headerHeader - 2) + 'px');
  }
}

window.addEventListener("load", (event) => {
  heightDrawerMenu();
});

window.addEventListener('scroll',(event) => {
  heightDrawerMenu();
});


document.addEventListener("DOMContentLoaded", function() {  
  var labels = document.querySelectorAll(".product__info-wrapper .product-form__input label[duree-utilisation");
  for (var i = 0; i < labels.length; i++) {
    labels[i].addEventListener('click', function(event) {
      var labels_duree = event.currentTarget.getAttribute("duree-utilisation");
      document.querySelector(".product .product__info-wrapper.grid__item .duree-utilisation").textContent = "Durée d'utilisation : " + labels_duree;
    });
  }
});


window.addEventListener("load", (event) => {
  const formEmbed = document.querySelector('.shopify-product-form just-pay-button');
  if (formEmbed && formEmbed.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      .just-btn{
        border-radius: 4px !important;
        overflow: hidden;
      }
    `;
    formEmbed.shadowRoot.appendChild(style);
  }
});


document.querySelectorAll('.slider-scinde.splide').forEach(function(splideElement) {
  var nb_slide = splideElement.querySelectorAll(".slider-scinde__slide").length;
  console.log("nb_slide =" + nb_slide);
  if ( nb_slide > 2 ){
    var splide = new Splide(splideElement, {
      type: 'loop',
      autoplay: true,
      autoWidth: true,
      interval: 4000,
      pauseOnHover: true,
      speed: 600,
      perPage: 1,
      direction: 'ltr',
      arrowPath: 'M7.73586 9.15007L0.292969 1.70718L1.70718 0.292969L10.5643 9.15007L1.70718 18.0072L0.292969 16.593L7.73586 9.15007Z',
      focus: 'left',
      gap: '30px',
      pagination: false,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: true,
      breakpoints: {
        750: {
          gap: '15px',
        }
      }
    });
    splide.mount();    
  }
});

document.querySelectorAll('.slider-scinde .splide__arrows .splide__arrow svg').forEach(function(svg) {
  svg.setAttribute("viewBox", "0 0 10 18");
  svg.setAttribute("width", "10");
  svg.setAttribute("height", "18");
});







